// =============================================================================
// Optim TURPE V2 : le formateur des nombres du module (démo du 20/10, point 3).
//
// Ce que le client doit vivre : « +1 739 € », jamais « +1739 € ». Le format
// français d'`Intl.NumberFormat` sépare les milliers par une espace fine
// insécable (U+202F) que la police de la page n'affiche pas. Chaque nombre du
// module passe donc par ce formateur, qui la remplace par l'espace insécable
// ordinaire (U+00A0) : le nombre reste sur une ligne, et l'espace se voit.
// =============================================================================

/** L'espace fine insécable (U+202F) que la police n'affiche pas. */
const ESPACE_FINE = /\u202f/g

/** Remplace l'espace fine insécable par l'espace insécable (U+00A0). */
export function espaceInsecableVisible(texte: string): string {
    return texte.replace(ESPACE_FINE, "\u00a0")
}

/** Un formateur `fr-FR` dont la sortie ne porte jamais d'U+202F. */
export type FormateurFr = { format: (valeur: number) => string }

/** `new Intl.NumberFormat("fr-FR", options)`, séparateur visible. */
export function formateurFr(options?: Intl.NumberFormatOptions): FormateurFr {
    const nf = new Intl.NumberFormat("fr-FR", options)
    return { format: (valeur) => espaceInsecableVisible(nf.format(valeur)) }
}

/**
 * La langue des champs de saisie numériques du module (rejeu du 20/10/2026,
 * A6). Le champ (`InputNumber`) formate lui-même sa valeur avec
 * `Intl.NumberFormat` et ne prend pas d'autre formateur ; sans langue, il
 * suit celle du navigateur : « 1,000 kW », lu « un kilowatt ». `fr-CA` est le
 * français dont les milliers se séparent par l'espace insécable ordinaire
 * (U+00A0) et les décimales par la virgule : le champ écrit donc exactement
 * ce qu'écrit `formateurFr` (« 1 000 kW », « 2,5 »), ce que vérifie
 * `optim-turpe-v2.nombre.spec.ts`. Le champ accepte « , » et « . » comme
 * virgule pour toute langue française.
 */
export const LOCALE_SAISIE = "fr-CA"
